import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@material-ui/core"
import {
  InputTextMaster,
  MasterButton,
  Modal,
  InputOptionMaster,
  InputReactDatepicker,
  InputFieldAsyncOption,
  InputTextLabel,
} from "App/Component/ui"
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  instance3,
  DISABLED_BUTTON_SUBMIT,
  TYPE_INSTANCE3,
  valueTipePembayaran,
  valueTipeKartu,
  TYPE_INSTANCE_HRIS,
} from "App/constants"
import {
  defaultToastError,
  titleModal,
  defaultToastSuccess,
  today,
  formatRupiah,
  convertToValidPrice,
  isNull,
  toUTCFormat,
  fetchData,
} from "App/utils/helpers"
import React, { Fragment, useState } from "react"
import { useSelectOption } from "App/hooks"
import { MSG_ERROR_TAGIHAN_NULL } from ".."
import { useEffect } from "react"
import { v4 as uuidv4 } from "uuid"

const urlDelete = "/bayar/delete"
const urlAdd = "/bayar/register"
const urlUpdate = "/bayar/update"
const urlGetKasBank = "/kas/kas/list-pemb-tagihan"

export const deleteBayarById = async (id) => {
  try {
    const res = await instance3.post(urlDelete, { id })
    if (res.data.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus data",
      }
    } else {
      return {
        state: false,
        message: res.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
    width: "50px",
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
    width: "50px",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    sort: false,
    align: "left",
    width: "50px",
  },
  {
    id: "tanggal",
    disablePadding: true,
    label: "TANGGAL",
    sort: false,
    align: "left",
  },
  {
    id: "jumlah_bayar",
    disablePadding: true,
    label: "JML BAYAR",
    sort: false,
    align: "left",
  },
  {
    id: "id_bayar_rekap",
    disablePadding: true,
    label: "SUMBER PEMBAYARAN",
    sort: false,
    align: "left",
  },
  {
    id: "isditanggung",
    disablePadding: true,
    label: "STATUS DITANGGUNG",
    sort: false,
    align: "left",
    width: "200px",
  },
  {
    id: "nama_kas",
    disablePadding: true,
    label: "KAS",
    sort: false,
    align: "left",
  },
  {
    id: "info",
    disablePadding: true,
    label: "TIPE BAYAR",
    sort: false,
    align: "left",
  },

  {
    id: "kembalian_saldo",
    disablePadding: true,
    label: "KEMBALIAN SALDO",
    sort: false,
    align: "left",
  },

  {
    id: "tipe_kartu",
    disablePadding: true,
    label: "TIPE KARTU",
    sort: false,
    align: "left",
  },
  {
    id: "no_kartu",
    disablePadding: true,
    label: "NO KARTU",
    sort: false,
    align: "left",
  },
  {
    id: "no_transaksi",
    disablePadding: true,
    label: "NO TRANS",
    sort: false,
    align: "left",
  },
]

export const RESET_STATE_BAYAR = {
  id: "",
  tanggal_masuk: today(true),
  jumlah_bayar2: "", // jumlah yang harus dibayar
  jumlah_bayar3: "", // jumlah uang pasien
  tipe_pembayaran_id: 1,
  kas_id: null,
  kas_name: "Pilih Kas",
  tipe_kartu: 1,
  no_transaksi: "",
  no_kartu: "",
  no_transfer: "",
  kartu_bank: "",
  kembalian: "",
  nik_pegawai: null,
  kode_potongan: null,
}

export const preLoadDataPegawai = async (inputValue) => {
  const res = await fetchData(
    TYPE_INSTANCE_HRIS,
    "master/pegawai/get-list-pegawai-hris",
    "data",
    {
      params: { search_key: isNull(inputValue) ? "" : inputValue },
    },
  )

  if (res) {
    const data = []

    res.map((item) => {
      return data.push({
        value: item.nik_pegawai,
        label: `${item.label} | ${item.nik_pegawai}`,
      })
    })

    return data
  }
}
export const preLoadDataPotongan = async (inputValue) => {
  const res = await fetchData(
    TYPE_INSTANCE_HRIS,
    "master/potongan/resource-bridging-simrs",
    "data",
    {
      params: { search_key: isNull(inputValue) ? "" : inputValue },
    },
  )

  if (res) {
    const data = []

    res.map((item) => {
      return data.push({
        value: item.kode_potongan,
        label: item.label,
      })
    })

    return data
  }
}

export const ModalForm = ({
  setShowModal,
  formData,
  setFormData,
  setNewData,
  tagihanId,
  status,
  totalSaldo,
  sisa,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT)
  const [confirmBayar, setConfirmBayar] = useState(false)

  const isTunai = formData.tipe_pembayaran_id?.toString() === "1"

  useEffect(() => {
    setFormData({
      ...formData,
      tanggal_masuk: today(true),
      tipe_pembayaran_id: totalSaldo > 0 ? 4 : 1,
      jumlah_bayar2:
        totalSaldo > 0 ? formatRupiah(totalSaldo) : formatRupiah(sisa), // total saldo
      nik_pegawai: null,
      kode_potongan: null,
    })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const add = async () => {
    const kembalianSaldo = hitungPembayaran().value

    return instance3.post(urlAdd, {
      tanggal_masuk: toUTCFormat(formData.tanggal_masuk),
      jumlah_bayar: convertToValidPrice(
        isTunai
          ? convertToValidPrice(formData.jumlah_bayar3) >
            convertToValidPrice(formData.jumlah_bayar2)
            ? convertToValidPrice(formData.jumlah_bayar3) -
              convertToValidPrice(kembalianSaldo)
            : formData.jumlah_bayar3
          : formData.jumlah_bayar2,
      ),
      tipe_pembayaran_id: formData.tipe_pembayaran_id,
      kas_id: formData.kas_id,
      tipe_kartu: formData.tipe_kartu,
      no_transaksi: formData.no_transaksi,
      no_kartu: formData.no_kartu,
      no_transfer: formData.no_transfer,
      kartu_bank: formData.kartu_bank,
      tagihan_id: tagihanId,
      kembalian_saldo:
        convertToValidPrice(formData.jumlah_bayar3) <=
        convertToValidPrice(formData.jumlah_bayar2)
          ? 0
          : convertToValidPrice(kembalianSaldo),
      nik_pegawai: formData?.nik_pegawai?.value ?? "",
      kode_potongan: formData?.kode_potongan?.value ?? "",
    })
  }

  const update = async () => {
    const kembalianSaldo = hitungPembayaran().value

    return instance3.post(urlUpdate, {
      id: formData.id,
      tanggal_masuk: toUTCFormat(formData.tanggal_masuk),
      jumlah_bayar: convertToValidPrice(
        isTunai
          ? convertToValidPrice(formData.jumlah_bayar3) >
            convertToValidPrice(formData.jumlah_bayar2)
            ? convertToValidPrice(formData.jumlah_bayar3) -
              convertToValidPrice(kembalianSaldo)
            : formData.jumlah_bayar3
          : formData.jumlah_bayar2,
      ),
      tipe_pembayaran_id: formData.tipe_pembayaran_id,
      kas_id: formData.kas_id,
      tipe_kartu: formData.tipe_kartu,
      no_transaksi: formData.no_transaksi,
      no_kartu: formData.no_kartu,
      no_transfer: formData.no_transfer,
      kartu_bank: formData.kartu_bank,
      tagihan_id: tagihanId,
      kembalian_saldo:
        convertToValidPrice(formData.jumlah_bayar3) <=
        convertToValidPrice(formData.jumlah_bayar2)
          ? 0
          : convertToValidPrice(kembalianSaldo),
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (isNull(tagihanId)) {
      return defaultToastError(MSG_ERROR_TAGIHAN_NULL)
    } else if (isNull(formData.kas_id)) {
      return defaultToastError("Kas tidak boleh kosong!")
    } else if (formData.tipe_pembayaran_id?.toString() === "6") {
      if (isNull(formData.nik_pegawai)) {
        return defaultToastError("Harap pilih Pegawai!")
      }
      if (isNull(formData.kode_potongan)) {
        return defaultToastError("Harap pilih Jenis Potongan!")
      }
    }

    setDisabled(DISABLED_BUTTON_SUBMIT)
    try {
      if (formData.id === "") {
        const res = await add()
        if (res.data.status === 200) {
          defaultToastSuccess("Berhasil menambah data")
          setShowModal(false)
          setNewData()
        } else {
          defaultToastError(res.data.message)
        }
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      } else {
        const res = await update()
        if (res.data.status === 200) {
          defaultToastSuccess("Berhasil mengubah data")
          setShowModal(false)
          setNewData()
        } else {
          defaultToastError(res.data.message)
        }
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      }
    } catch (error) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      defaultToastError(error?.response?.data?.message)
    }
  }

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    })
  }

  const tipePembayaran = valueTipePembayaran

  const kasBank = useSelectOption(
    true,
    urlGetKasBank,
    TYPE_INSTANCE3,
    "id",
    "nama",
  )

  const hitungPembayaran = () => {
    const total = convertToValidPrice(formData.jumlah_bayar2)
    const jumlah = convertToValidPrice(formData.jumlah_bayar3)

    if (jumlah > total) {
      return {
        label: "Jumlah Kembalian",
        value: formatRupiah(+jumlah - +total),
      }
    } else if (jumlah < total) {
      return {
        label: "Jumlah Kekurangan",
        value: formatRupiah(+total - +jumlah),
      }
    } else {
      return {
        label: "-",
        value: 0,
      }
    }
  }

  const onSubmit = (e) => {
    e.preventDefault()
    if (
      convertToValidPrice(formData.jumlah_bayar3) <
        convertToValidPrice(formData.jumlah_bayar2) &&
      isTunai
    ) {
      setConfirmBayar(true)
    } else {
      handleSubmit(e)
    }
  }

  return (
    <Fragment>
      <Dialog
        open={confirmBayar}
        onClose={() => {
          setConfirmBayar(false)
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          PERHATIAN
        </DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            Jumlah pembayaran kurang dari total pembayaran
          </Typography>
          <Typography gutterBottom>
            Kekurangan : Rp. {hitungPembayaran().value}
          </Typography>
        </DialogContent>
        <DialogActions>
          <MasterButton
            name="Lanjutkan"
            type="button"
            outline
            color="danger"
            onClick={(e) => handleSubmit(e)}
          />
          <MasterButton
            name="Kembali"
            type="button"
            onClick={(e) => setConfirmBayar(false)}
          />
        </DialogActions>
      </Dialog>
      <Modal
        title={`${titleModal(formData.id)} Bayar`}
        width="50%"
        show={setShowModal}
      >
        <form action="POST" onSubmit={(e) => onSubmit(e)}>
          <InputTextMaster
            type="hidden"
            name="id"
            id="id"
            readOnly={true}
            value={formData.id}
          />
          <Grid container spacing={2}>
            <Grid
              item
              sm={formData.tipe_pembayaran_id.toString() === "2" ? 6 : 12}
            >
              <Grid container spacing={1}>
                <Grid item sm={12}>
                  {/* <InputTextMaster
                  name='tanggal_masuk'
                  label='TANGGAL'
                  id='tanggal_masuk'
                  value={formData.tanggal_masuk}
                  onChange={handleChange("tanggal_masuk")}
                  placeholder='Nama'
                  type={"datetime-local"}
                /> */}

                  <InputReactDatepicker
                    selected={formData.tanggal_masuk}
                    label="TANGGAL"
                    dateFormat="dd/MM/yyyy HH:mm"
                    timeFormat="HH:mm"
                    showTimeSelect
                    timeIntervals={5}
                    handleChangeToday={(e) =>
                      setFormData({
                        ...formData,
                        tanggal_masuk: e,
                      })
                    }
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        tanggal_masuk: e,
                      })
                    }
                  />
                </Grid>
                <Grid item sm={12}>
                  <InputOptionMaster
                    name="tipe_pembayaran_id"
                    label="TIPE PEMBAYARAN"
                    id="tipe_pembayaran_id"
                    withSearch={false}
                    disabled={totalSaldo > 0 ? true : false}
                    readOnly={totalSaldo > 0 ? true : false}
                    value={formData.tipe_pembayaran_id}
                    onChange={handleChange("tipe_pembayaran_id")}
                    data={tipePembayaran}
                  />
                </Grid>
                {formData.tipe_pembayaran_id?.toString() === "6" ? (
                  <Grid
                    item
                    sm={12}
                    style={{
                      backgroundColor: "#F5F5F5",
                      padding: "10px",
                      border: "1px solid #eaeaea",
                      borderRadius: "3px",
                      margin: "8px 4px",
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid item sm={6}>
                        <InputTextLabel label={"Pegawai"} id={"pegawai"} />
                        <InputFieldAsyncOption
                          name="Pegawai"
                          label="Pegawai"
                          defaultLabel="/ Cari Pegawai..."
                          id={uuidv4()}
                          needParse={false}
                          withSearch={true}
                          data={[]}
                          loadOptions={preLoadDataPegawai}
                          value={formData.nik_pegawai?.value}
                          labelValue={formData.nik_pegawai?.label}
                          defaultData={formData.nik_pegawai?.label}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              nik_pegawai: e ?? null,
                            })
                          }}
                        />
                      </Grid>
                      <Grid item sm={6}>
                        <InputTextLabel
                          label={"Jenis Potongan"}
                          id={"potongan"}
                        />
                        <InputFieldAsyncOption
                          name="Potongan"
                          label="Potongan"
                          defaultLabel="/ Cari Jenis Potongan..."
                          id={uuidv4()}
                          needParse={false}
                          withSearch={true}
                          data={[]}
                          loadOptions={preLoadDataPotongan}
                          value={formData.kode_potongan?.value}
                          labelValue={formData.kode_potongan?.label}
                          defaultData={formData.kode_potongan?.label}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              kode_potongan: e ?? null,
                            })
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                ) : (
                  <></>
                )}
                <Grid item sm={12}>
                  <InputOptionMaster
                    name="kas_id"
                    label="KAS"
                    id="kas_id"
                    data={kasBank}
                    withSearch={true}
                    value={formData.kas_id}
                    labelValue={formData.kas_name}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        kas_id: e?.value,
                        kas_name: e?.label,
                      })
                    }}
                  />
                </Grid>
                {formData.tipe_pembayaran_id?.toString() === "1" ? (
                  <Grid
                    item
                    sm={12}
                    style={{
                      backgroundColor: "#F5F5F5",
                      padding: "10px",
                      border: "1px solid #eaeaea",
                      borderRadius: "3px",
                      margin: "8px 4px",
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid item sm={6}>
                        <InputTextMaster
                          name="jumlah_bayar2"
                          label="TOTAL TAGIHAN"
                          placeholder="Total Pembayaran"
                          id="jumlah_bayar2"
                          disabled={totalSaldo > 0 ? true : false}
                          readOnly={totalSaldo > 0 ? true : false}
                          value={formData.jumlah_bayar2}
                          onInput={(e) => {
                            let val = e.target.value
                            setFormData({
                              ...formData,
                              jumlah_bayar2: formatRupiah(val),
                            })
                          }}
                        />
                      </Grid>
                      <Grid item sm={6}>
                        <InputTextMaster
                          name="jumlah_bayar2"
                          label="JUMLAH PEMBAYARAN"
                          id="jumlah_bayar2"
                          placeholder="Jumlah Pembayaran"
                          disabled={totalSaldo > 0 ? true : false}
                          readOnly={totalSaldo > 0 ? true : false}
                          value={formData.jumlah_bayar3}
                          onInput={(e) => {
                            let val = e.target.value
                            setFormData({
                              ...formData,
                              jumlah_bayar3: formatRupiah(val),
                            })
                          }}
                        />
                      </Grid>
                      {formData.jumlah_bayar2 !== formData.jumlah_bayar3 && (
                        <Grid item sm={12}>
                          <InputTextMaster
                            name="kembalian"
                            label={hitungPembayaran().label.toUpperCase()}
                            id="kembalian"
                            placeholder={hitungPembayaran().label}
                            disabled
                            value={hitungPembayaran().value}
                          />
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                ) : (
                  <Grid item sm={12}>
                    <InputTextMaster
                      name="jumlah_bayar2"
                      label="TOTAL PEMBAYARAN"
                      placeholder="Total Pembayaran"
                      id="jumlah_bayar2"
                      disabled={totalSaldo > 0 ? true : false}
                      readOnly={totalSaldo > 0 ? true : false}
                      value={formData.jumlah_bayar2}
                      onInput={(e) => {
                        let val = e.target.value
                        setFormData({
                          ...formData,
                          jumlah_bayar2: formatRupiah(val),
                        })
                      }}
                    />
                  </Grid>
                )}
              </Grid>
            </Grid>
            {formData.tipe_pembayaran_id.toString() === "2" && (
              <Grid item sm={6}>
                <Grid container spacing={1}>
                  <FormTipeKartuNoKartuDanNoTransfer
                    formData={formData}
                    handleChange={handleChange}
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MasterButton
              className={"mt-1"}
              type="submit"
              color={disabled.color}
              name={disabled.label}
              size="md"
            />
          </Grid>
        </form>
      </Modal>
    </Fragment>
  )
}

export const FormTipeKartuNoKartuDanNoTransfer = ({
  formData,
  handleChange,
}) => {
  return (
    <>
      <Grid item sm={12}>
        <InputOptionMaster
          name="tipe_kartu"
          label="TIPE KARTU"
          id="tipe_kartu"
          withSearch={false}
          value={formData.tipe_kartu}
          onChange={handleChange("tipe_kartu")}
          data={valueTipeKartu}
        />
      </Grid>

      <Grid item sm={12}>
        <InputTextMaster
          name="no_kartu"
          label="NO KARTU"
          id="no_kartu"
          value={formData.no_kartu}
          onChange={handleChange("no_kartu")}
          placeholder="No Kartu"
        />
      </Grid>

      <Grid item sm={12}>
        <InputTextMaster
          name="no_transfer"
          label="NO TRANSAKI"
          id="no_transfer"
          value={formData.no_transfer}
          onChange={handleChange("no_transfer")}
          placeholder="No Transaksi"
        />
      </Grid>
    </>
  )
}
